var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": true,
              "show-delete": false,
              "show-save": false,
              "show-cancel": false,
              "show-new": false,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          _c("div", { staticClass: "columns is-gapless" }, [
            _c(
              "div",
              { staticClass: "column is-narrow" },
              [
                _c("sales-analysis-list-side-menu", {
                  on: { filter: _vm.filterList, reset: _vm.resetList },
                  model: {
                    value: _vm.filter,
                    callback: function ($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter",
                  },
                }),
              ],
              1
            ),
            _c("div", { staticClass: "column is-wrapped" }, [
              _c("div", { staticClass: "tile is-parent" }, [
                _c(
                  "article",
                  { staticClass: "tile is-child box" },
                  [
                    _c(
                      "bulma-table",
                      {
                        staticClass:
                          "table is-bordered is-striped is-narrow is-fullwidth",
                        attrs: {
                          columns: _vm.columns,
                          "page-index": _vm.filter.pageIndex,
                          "page-size": _vm.filter.pageSize,
                          "total-rows": _vm.totalRows,
                          "is-loading": _vm.isTableLoading,
                          "sort-column": _vm.filter.sortColumn,
                          "sort-order": _vm.filter.sortOrder,
                        },
                        on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                      },
                      [
                        _vm._l(_vm.entitySummaries, function (entity, index) {
                          return _c(
                            "tr",
                            {
                              key: entity.assetId,
                              class: {
                                "is-selected": _vm.selectedRow === index,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.highlightSelected(index, $event)
                                },
                              },
                            },
                            [
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatDateTimezone(
                                      entity.invoiceDate,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", [_vm._v(_vm._s(entity.debtorName))]),
                              _vm.$company.isCategoryEnabled(
                                _vm.itemCategoryTypes.RR
                              )
                                ? _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          entity.rrTotal,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.$company.isCategoryEnabled(
                                _vm.itemCategoryTypes.RWA
                              )
                                ? _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          entity.rwaTotal,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.$company.isCategoryEnabled(
                                _vm.itemCategoryTypes.REP
                              )
                                ? _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          entity.repairTotal,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.$company.isCategoryEnabled(
                                _vm.itemCategoryTypes.PAINT
                              )
                                ? _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          entity.paintTotal + entity.opgTotal,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.$company.isCategoryEnabled(
                                _vm.itemCategoryTypes.FIBER
                              )
                                ? _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          entity.fgTotal,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.$company.isCategoryEnabled(
                                _vm.itemCategoryTypes.CRUSH
                              )
                                ? _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          entity.crushTotal,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.$company.isCategoryEnabled(
                                _vm.itemCategoryTypes.CD
                              )
                                ? _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          entity.cdTotal,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.$company.isCategoryEnabled(
                                _vm.itemCategoryTypes.MECH
                              )
                                ? _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          entity.mechTotal,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.$company.isCategoryEnabled(
                                _vm.itemCategoryTypes.PART
                              )
                                ? _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          entity.partTotal,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.$company.isCategoryEnabled(
                                _vm.itemCategoryTypes.MISC
                              )
                                ? _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          entity.miscTotal,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.$company.isCategoryEnabled(
                                _vm.itemCategoryTypes.SUBL
                              )
                                ? _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          entity.subletTotal,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.$company.isCategoryEnabled(
                                _vm.itemCategoryTypes.PDRRR
                              )
                                ? _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          entity.pdrrrTotal,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _vm.$company.isCategoryEnabled(
                                _vm.itemCategoryTypes.PDRRE
                              )
                                ? _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatNumber(
                                          entity.pdrreTotal,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatNumber(
                                      entity.painM,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatNumber(
                                      entity.orTotals,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatNumber(
                                      entity.excessAmount,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatNumber(
                                      entity.totalExGST,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatNumber(
                                      entity.gst,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", { staticClass: "has-text-right" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$filters.formatNumber(
                                      entity.totalIncGst,
                                      _vm.$userInfo.locale
                                    )
                                  )
                                ),
                              ]),
                              _c("td", [_vm._v(_vm._s(entity.invoiceNo))]),
                              _c("td", [_vm._v(_vm._s(entity.quoteNo))]),
                              _c("td", [_vm._v(_vm._s(entity.claimNo))]),
                              _c("td", [_vm._v(_vm._s(entity.rego))]),
                              _c("td", [_vm._v(_vm._s(entity.ownerName))]),
                            ]
                          )
                        }),
                        _c("template", { slot: "empty" }, [
                          _c("section", { staticClass: "section" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "content has-text-grey has-text-centered",
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { icon: "icon is-large" } },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "mdi mdi-48px mdi-emoticon-sad",
                                    }),
                                  ]
                                ),
                                _c("p", [_vm._v("Nothing")]),
                              ]
                            ),
                          ]),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
          _vm.isPrintSalesAnalysisModalActive
            ? _c("sales-analysis-print-modal", {
                attrs: { active: _vm.isPrintSalesAnalysisModalActive },
                on: {
                  "update:active": function ($event) {
                    _vm.isPrintSalesAnalysisModalActive = $event
                  },
                  print: _vm.printSalesAnalysis,
                  export: _vm.exportToExcel,
                  close: _vm.closePrint,
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }